// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoScratchpad, {type ScratchpadPayload} from '@app/features/konvo_scratchpad/state/KonvoScratchpad';

export function handleKonvoScratchpadUpdate(data: ScratchpadPayload, _context: GatewayHandlerContext): void {
	if (!data || typeof data.content !== 'string') return;
	KonvoScratchpad.applyRemote(data);
}
